import { render, staticRenderFns } from "./ReferralSourceAttributePopover.vue?vue&type=template&id=63954f2d"
import script from "./ReferralSourceAttributePopover.vue?vue&type=script&lang=js"
export * from "./ReferralSourceAttributePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports